import MicPermissionModal from '@shared/layouts/app-layout/components/modal/modal-mic-permisssion';
import { useMicPermissionStore } from '@modules/phone/store/mic-permission.store';

export function MicPermissionGate() {
  const { micPermissionDenied, setMicPermissionDenied } = useMicPermissionStore();

  return <MicPermissionModal open={micPermissionDenied} onClose={() => setMicPermissionDenied(false)} />;
}
